import { ImageCoverView, ImageScaleView } from '@play-co/timestep-core/ui';
import { ImageScaleViewOpts } from '@play-co/timestep-core/lib/ui/ImageScaleView';

export default class LockedButtonOverlay extends ImageScaleView {
  private padLock: ImageCoverView;
  constructor(opts: Omit<ImageScaleViewOpts, 'image'>) {
    super({
      ...opts,
      image: 'assets/ui/shared/buttons/btn_disabled_overlay.png',
    });
    this.padLock = this.addSubview(
      new ImageCoverView({
        image: 'assets/ui/shared/icons/footer_locked.png',
        width: 50,
        height: 59,
        x: this.style.width - 55,
        y: -14,
      }),
    );
  }

  public setSize(width: number, height: number) {
    this.updateOpts({ width, height });
    this.padLock.updateOpts({
      x: width - 55,
      y: -14,
    });
  }
}
